module.exports = __webpack_public_path__ + "img/games05.89824567.png";